module.exports = __webpack_public_path__ + "img/Gambia.1ace3cb9.gif";